// AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { getEncryptedStorageValue, getStorageValue, setStorageValue } from "./helper";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    getEncryptedStorageValue('accessToken') !== undefined && getEncryptedStorageValue('accessToken') !== null
  );
  const userInfo = useState(getStorageValue('userInfo') || {});

  useEffect(() => {
    setStorageValue("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  const login = () => setIsLoggedIn(true);
  const logout = () => setIsLoggedIn(false);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, userInfo }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
